import React from "react";
import {GetStatusType, ProductByCategoryType} from "@/lib/type/product-center";

type Props = {
    status?:GetStatusType
}
const ProductSelection:React.FC<Props> = ({status}) => {

    return <div>

    </div>
}

export default ProductSelection